import { createStyles } from 'antd-style';

export const useStyle = createStyles(({ css }) => ({
  customTable: css`
    .ant-table {
      .ant-table-container {
        .ant-table-body,
        .ant-table-content {
          scrollbar-width: thin;
          scrollbar-color: #eaeaea transparent;
          scrollbar-gutter: stable;
        }
      }
    }
  `,
  customScroolModal: css`
    .ant-modal-content{
      padding: 0px;
      .ant-modal-header{
        padding: 20px;
        padding-bottom:0px;
      }
      .ant-modal-body{
        .ant-carousel{
          .slick-arrow{
            color: #535353;
          }
          .slick-track > div > div{
            padding:20px 26px;
            padding-top:8px;
          }
          .slick-dots{
            button{
              background-color: #535353;
            }
          }
        }
      }

      .ant-modal-body > :not(.ant-carousel) {
        padding:0px 22px;
      }

      .ant-modal-body > :last-child:not(.ant-carousel) {
        padding-bottom: 22px;
      }
    }
  `,
  customSmallDescHead: css`
      .ant-descriptions-header{
        margin-bottom:8px;
      }
  `
}));
